import { defineStore } from 'pinia'
import api from '@/services/api'
import { useAuthStore } from './auth'


export const usePlanosStore = defineStore('planos', {
  state: () => ({
    authStore: useAuthStore(),
    planos: []
  }),
  actions: {
    async get() {
        
        const result = await api.get('/planos', {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        this.planos = result.data
    },
    async getOne(id) {
        
        const result = await api.get(`/planos/${id}`, {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })

        if(result.data.id)
        {  
          return {status : true, plano: result.data}
        }else{
          return {status : false, message : result.data.message}
        }
        
    },
    async add(plano) {
        
      if(!plano.parcerias.length) delete plano.parcerias

      const result = await api.post('/planos', plano, {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        
        if(result.data.id)
        {  
          return {status : true}
        }else{
          return {status : false, message : result.data.message}
        }

    },
    async update(plano){

      if(!plano.parcerias.length) delete plano.parcerias
      
      const result = await api.put(`/planos/${plano.id}`, plano, {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        
        if(result.data.id)
        {  
          return {status : true}
        }else{
          return {status : false, message : result.data.message}
        }

    },
    async delete(plano){

      const result = await api.delete(`/planos/${plano.id}`, {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        
        if(result.data.id)
        {  
          return {status : true}
        }else{
          return {status : false, message : result.data.message}
        }

    } 
  }
})